var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentSettingsDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6 0C0.268629 0 0 0.26863 0 0.600001V9.4C0 9.73137 0.268629 10 0.6 10H7.4C7.73137 10 8 9.73137 8 9.4V3.5H5.6C4.99249 3.5 4.5 3.00752 4.5 2.4V0H0.6ZM5.5 0.000715519V2.4C5.5 2.45523 5.54477 2.5 5.6 2.5H8V2.47571C8 2.31365 7.93444 2.15849 7.81825 2.04552L6.85714 1.11111L5.88894 0.169803C5.78397 0.0677452 5.64557 0.00782904 5.5 0.000715519Z",
    fill: "#e0e0e0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSettingsDefault);
export default __webpack_public_path__ + "static/media/document-settings-default.4eebbb2feb6193cc99d40a2764a575a5.svg";
export { ForwardRef as ReactComponent };